/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriversRow,
    DriversRowFromJSON,
    DriversRowFromJSONTyped,
    DriversRowToJSON,
} from './';

/**
 * 乗務員リスト
 * @export
 * @interface DriversList
 */
export interface DriversList {
    /**
     * 
     * @type {Array<DriversRow>}
     * @memberof DriversList
     */
    drivers?: Array<DriversRow>;
}

export function DriversListFromJSON(json: any): DriversList {
    return DriversListFromJSONTyped(json, false);
}

export function DriversListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriversList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drivers': !exists(json, 'drivers') ? undefined : ((json['drivers'] as Array<any>).map(DriversRowFromJSON)),
    };
}

export function DriversListToJSON(value?: DriversList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drivers': value.drivers === undefined ? undefined : ((value.drivers as Array<any>).map(DriversRowToJSON)),
    };
}


